import axios from "axios";
import consoleLog from "../utils/consoleLog";

// import { Item } from "../redux/shop/shop.types";

import {
  transformCollection,
  transformProductOrVariant,
  transformProducts,
} from "../redux/shop/shop.utils";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_PETOBE_SHOPPING_DASHBOARD_API_BASE_URL_DEV}`
      : `${process.env.REACT_APP_PETOBE_SHOPPING_DASHBOARD_API_BASE_URL_PROD}`,
});

// export const checkIdToken = async () => {
//   console.log("checkIdToken called");

//   return await API.get("/checkIdToken")
//     .then((res) => {
//       consoleLog("checkIdToken response", res);
//       return res.data;
//     })
//     .catch((err) => {
//       consoleLog("checkIdToken error", err);
//       // throw new Error(err);
//     });
// };

export const getAllCollection = async () => {
  return await API.get("/collection/getAllCollection", {
    transformResponse: [
      (res: any) => {
        const parsedData = JSON.parse(res);
        return Object.values(parsedData.body);
      },
    ],
  })
    .then((res) => {
      consoleLog("getAllCollection response", res);
      return res.data;
    })
    .catch((err) => {
      consoleLog("getAllCollection error", err);
      throw new Error(err);
    });
};

export const getAllBrand = async () => {
  return await API.get("/brand/getAllBrand", {
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        return parsedRes.body.sort((a: any, b: any) =>
          a.brandName > b.brandName ? 1 : -1,
        );
      },
    ],
  })
    .then((res) => {
      consoleLog("getAllBrand response", res);
      return res.data;
    })
    .catch((err) => {
      consoleLog("getAllBrand error", err);
      throw new Error(err);
    });
};

export const searchProductByCollection = async ({
  collectionIdList,
  filters,
  extraFilters,
  sortBy,
}: {
  collectionIdList: string[];
  filters?: any;
  extraFilters?: any;
  sortBy?: string;
}) => {
  consoleLog("searchProductByCollection request body", {
    collectionIdList,
    filters,
    extraFilters,
    sortBy,
  });

  return await API.post(
    "/search/searchProductByCollection",
    {
      collectionIdList,
      filters,
      extraFilters,
      sortBy,
    },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);

          if (!parsedRes.body || Object.keys(parsedRes.body).length === 0) {
            return parsedRes;
          }
          parsedRes.body.products = transformProducts(parsedRes.body.products);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("searchProductByCollection response", res);
      return Object.keys(res.data.body).length !== 0
        ? res.data.body.products
        : [];
    })
    .catch((err) => {
      consoleLog("searchProductByCollection error", err);
      throw new Error(err);
    });
};

export const searchProductByKeyword = async ({
  searchKeyword,
  searchTitle,
  onlyActive,
  onlyCollectionExists,
  filters,
  extraFilters,
  sortBy,
}: {
  searchKeyword: string;
  searchTitle: string;
  onlyActive?: string;
  onlyCollectionExists?: string;
  filters?: any;
  extraFilters?: any;
  sortBy?: string;
}) => {
  consoleLog("searchProductByKeyword request body", {
    searchKeyword,
    searchTitle,
    onlyActive,
    onlyCollectionExists,
    filters,
    extraFilters,
    sortBy,
  });

  return await API.post(
    "/search/searchProductByKeyword",
    {
      searchKeyword,
      searchTitle,
      onlyActive,
      onlyCollectionExists,
      filters,
      extraFilters,
      sortBy,
    },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);

          if (!parsedRes.body || Object.keys(parsedRes.body).length === 0) {
            return parsedRes;
          }
          parsedRes.body.products = transformProducts(parsedRes.body.products);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("searchProductByKeyword response", res);
      return Object.keys(res.data.body).length !== 0
        ? res.data.body.products
        : [];
    })
    .catch((err) => {
      consoleLog("searchProductByKeyword error", err);
      throw new Error(err);
    });
};

export const getCollection = async (collectionId: string) => {
  consoleLog("getCollection request body", { collectionId });

  return await API.post(
    "/collection/getCollection",
    { collectionId },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          const { body } = parsedRes;
          body.collection = {
            ...transformCollection(body.collection),
            filterList: body.filters,
          };

          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("getCollection response", res);
      return res?.data?.body?.collection;
    })
    .catch((err) => {
      consoleLog("getCollection error", err);
      throw new Error(err);
    });
};

export const getBrandById = async (brandId: string) => {
  consoleLog("getBrandById request body", { brandId });

  return await API.post(
    "/brand/getBrandById",
    { brandId },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);

          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("getBrandById response", res);
      return res?.data?.body;
    })
    .catch((err) => {
      consoleLog("getBrandById error", err);
      throw new Error(err);
    });
};

export const countFilteredItems = async (collectionId: string) => {
  consoleLog("countFilteredItems request body", { collectionId });

  return await API.post(
    "/count/countFilteredItems",
    { collectionId },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);

          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("countFilteredItems response", res);
      return res?.data?.body;
    })
    .catch((err) => {
      consoleLog("countFilteredItems error", err);
      throw new Error(err);
    });
};

export const countFromProducts = async (brandName: string) => {
  consoleLog("countFromProducts request body", { brandName });

  return await API.post(
    "/count/countFromProducts",
    { brandName },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);

          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("countFromProducts response", res);
      return res?.data?.body;
    })
    .catch((err) => {
      consoleLog("countFromProducts error", err);
      throw new Error(err);
    });
};

export const getCollections = async (collectionIdList: string[]) => {
  consoleLog("getCollections request body", { collectionIdList });

  return await API.post(
    "/collection/getCollections",
    { collectionIdList },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          const { body } = parsedRes;
          body.collections = body.collections
            .filter(
              (collection: any) => collection.name.toLowerCase() !== "pet",
            )
            .map((collection: any) => transformCollection(collection))
            .sort((a: any, b: any) =>
              a.parentCollectionList.length > b.parentCollectionList.length
                ? 1
                : -1,
            );

          return parsedRes.body;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("getCollections response", res);
      return res?.data?.collections;
    })
    .catch((err) => {
      consoleLog("getCollections error", err);
      throw new Error(err);
    });
};

export const getProduct = async (productId: string) => {
  consoleLog("getProduct request body", { productId });

  return await API.get("/product/getProduct", {
    params: { productId },
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        parsedRes.body = transformProductOrVariant(parsedRes.body);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("getProduct response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getProduct error", err);
      throw new Error(err);
    });
};

export const getVariant = async (productId: string, variantId: string) => {
  consoleLog("getVariant request body", { productId, variantId });

  return await API.get("/product/getVariant", {
    params: { productId, variantId },
    transformResponse: [
      (res: any) => {
        const parsedRes = JSON.parse(res);
        parsedRes.body = transformProductOrVariant(parsedRes.body);
        return parsedRes;
      },
    ],
  })
    .then((res) => {
      consoleLog("getVariant response", res);
      return res.data.body;
    })
    .catch((err) => {
      consoleLog("getVariant error", err);
      throw new Error(err);
    });
};

// ####################################################
// NOT USED
//  | | | | | | | | | | | | | | | | | | | | | | | | | |
// \/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
// ####################################################

// const pets = ["dog", "cat", "bird", "reptile", "smallpets", "fish"];

// const getPetType = (item: any) => item.pkCollection.split("#")[0].toLowerCase();
// const getItemType = (item: any) =>
//   item.productCollection.split("#")[0].toLowerCase();
// const getCategory = (item: any) =>
//   item.productCollection.split("#")[1].toLowerCase();
// const getItemId = (item: any) =>
//   item.productCollection.split("#")[2].toLowerCase();

// const convertItemForClient = (item: any) => {
//   const itemForClient: Item = {
//     id: getItemId(item),
//     petType: getPetType(item),
//     itemType: getItemType(item),
//     category: getCategory(item),
//     name: item.name,
//     price: item.price,
//     discountRate: item.data.discountRate,
//     brand: item.brand,
//     shortDescription: item.data.description,
//     dateAdded: new Date(item.created),
//     isSoldOut: item.isSoldOut,
//     isPopular: item.isPopular,
//     isOnSale: item.isOnSale,
//     avgRating: item.avgRating,
//     reviews: item.data.reviews,
//     images: item.data.images,
//   };
//   return itemForClient;
// };

// export const getSampleProductData = (action: fetchActionType) =>
//   API.get("/getSampleProductData", {
//     params: action.payload.params,
//     transformResponse: [
//       (data: any) => {
//         const parsedData = JSON.parse(data);
//         const parsedBody = JSON.parse(parsedData.body);
//         const transformedData = parsedBody.items.map((item: any) =>
//           convertItemForClient(item),
//         );
//         return transformedData;
//       },
//     ],
//   })
//     .then((res) => res.data)
//     .catch((err) => err.message);

// export const getJustInCollectionData = () => {
//   return pets.map((pet) => {
//     return API.get("/getSampleProductData", {
//       params: {
//         petType: pet,
//         subPetType: pet,
//       },
//       transformResponse: [
//         (data: any) => {
//           const parsedData = JSON.parse(data);
//           const parsedBody = JSON.parse(parsedData.body);
//           const filteredItems = parsedBody.items.filter(
//             (item: any) =>
//               new Date().getTime() - new Date(item.created).getTime() <
//               2629800000,
//           );
//           const transformedData = filteredItems.map((item: any) =>
//             convertItemForClient(item),
//           );
//           return transformedData;
//         },
//       ],
//     })
//       .then((res) => res.data)
//       .catch((err) => err.message);
//   });
// };

// export const getSpecialCollectionData = () => {
//   return pets.map((pet) => {
//     return API.get("/getSampleProductData", {
//       params: {
//         petType: pet,
//         subPetType: pet,
//       },
//       transformResponse: [
//         (data: any) => {
//           const parsedData = JSON.parse(data);
//           const parsedBody = JSON.parse(parsedData.body);
//           const filteredItems = parsedBody.items.filter(
//             (item: any) => item.isOnSale,
//           );
//           const transformedData = filteredItems.map((item: any) =>
//             convertItemForClient(item),
//           );
//           return transformedData;
//         },
//       ],
//     })
//       .then((res) => res.data)
//       .catch((err) => err.message);
//   });
// };
